(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var lottieEls = document.querySelectorAll('.ootb-how__lottie');
    if (lottieEls.length && window.lottie) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      lottieEls.forEach(function (el) {
        window.lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: !reduceMotion,
          path: el.getAttribute('data-lottie-src')
        });
      });
    }

    var steps = document.querySelectorAll('.ootb-how__step');
    if (!steps.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      steps.forEach(function (step) { io.observe(step); });
    } else {
      steps.forEach(function (step) { step.classList.add('is-visible'); });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    steps.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(800px) rotateX(' + (y * -5) + 'deg) rotateY(' + (x * 5) + 'deg) scale(1.012)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  });
})();
